import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleNavigation = (path: string) => {
    if (path.startsWith('/#')) {
      const sectionId = path.substring(2);
      scrollToSection(sectionId);
    } else {
      navigate(path);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-blue-600 via-teal-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-white/20 to-white/10 rounded-xl flex items-center justify-center">
                <i className="ri-window-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold">AccèsDemandes</h3>
                <p className="text-sm text-white/80">Demandes Qualifiées</p>
              </div>
            </div>
            <p className="text-white/80 mb-6">
              Votre partenaire de confiance pour des demandes fenêtres qualifiées et vérifiées.
            </p>
            <div className="flex gap-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6">Liens Rapides</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-white/80 hover:text-white transition-colors cursor-pointer text-left">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('whatsapp-alerts')} className="text-white/80 hover:text-white transition-colors cursor-pointer text-left">
                  Alertes WhatsApp
                </button>
              </li>
              <li>
                <button onClick={() => handleNavigation('/expertises')} className="text-white/80 hover:text-white transition-colors cursor-pointer text-left">
                  Expertises
                </button>
              </li>
              <li>
                <button onClick={() => handleNavigation('/conseils')} className="text-white/80 hover:text-white transition-colors cursor-pointer text-left">
                  Conseils
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('faq')} className="text-white/80 hover:text-white transition-colors cursor-pointer text-left">
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6">Nos Services</h4>
            <ul className="space-y-3">
              <li className="text-white/80">Demandes Fenêtres PVC</li>
              <li className="text-white/80">Demandes Fenêtres Alu</li>
              <li className="text-white/80">Demandes Baies Vitrées</li>
              <li className="text-white/80">Demandes Rénovation</li>
              <li className="text-white/80">Alertes WhatsApp</li>
            </ul>
          </div>

          {/* Contact + Back Office */}
          <div>
            <h4 className="text-lg font-bold mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-white text-xl mt-1"></i>
                <div>
                  <p className="text-white/80">Email</p>
                  <a href="mailto:contact@accesdemandes.fr" className="text-white hover:text-white/80 transition-colors cursor-pointer">
                    contact@accesdemandes.fr
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-white text-xl mt-1"></i>
                <div>
                  <p className="text-white/80">Téléphone</p>
                  <a href="tel:+33187660900" className="text-white hover:text-white/80 transition-colors cursor-pointer">
                    +33 1.87.66.09.00
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-whatsapp-line text-white text-xl mt-1"></i>
                <div>
                  <p className="text-white/80">WhatsApp</p>
                  <a href="https://wa.me/33745883392" target="_blank" rel="noopener noreferrer" className="text-white hover:text-white/80 transition-colors cursor-pointer">
                    07 45 88 33 92
                  </a>
                </div>
              </li>
            </ul>

            {/* Admin Back Office Button */}
            <div className="mt-8 pt-6 border-t border-white/20">
              <button 
                onClick={() => handleNavigation('/admin')} 
                className="w-full bg-white/10 hover:bg-white/20 text-white font-semibold py-3 px-4 rounded-lg transition-all duration-300 flex items-center justify-center gap-2 cursor-pointer group"
              >
                <i className="ri-admin-line text-lg group-hover:scale-110 transition-transform"></i>
                <span>Back Office Admin</span>
              </button>
              <p className="text-xs text-white/60 text-center mt-2">Gestion des leads - Administrateurs</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/80 text-sm">
              © 2024 AccèsDemandes. Tous droits réservés.
            </p>
            <div className="flex gap-6">
              <button onClick={() => handleNavigation('/mentions-legales')} className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer">
                Mentions Légales
              </button>
              <button onClick={() => handleNavigation('/mentions-legales')} className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer">
                Confidentialité
              </button>
              <button onClick={() => handleNavigation('/mentions-legales')} className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer">
                CGV
              </button>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}